import { useState } from 'react'

import CogIcon from '@heroicons/react/outline/CogIcon'
import PencilAltIcon from '@heroicons/react/outline/PencilAltIcon'
import XIcon from '@heroicons/react/outline/XIcon'

import { Space } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Hotkey } from '@tribeplatform/react-ui-kit/Hotkey'

import { useQuery } from '../../lib/useQuery'
import { SpaceSettingsModal } from '../Admin/Spaces/SpaceSettingsModal'

export const NewSpaceBanner = ({ space }: { space: Space }) => {
  const { id, relativeUrl } = space

  const query = useQuery()
  const { push } = useRouter()

  const [spaceSettingsModal, setSpaceSettingsModal] = useState(null)

  if (!query?.new) {
    return null
  }
  return (
    <>
      <Card className="fixed z-10 bottom-0 end-0 m-5">
        <Card.Content className="flex flex-col space-y-3">
          <div className="flex space-s-5">
            <div className="flex-1 flex-col space-y-2">
              <h4>
                <T
                  defaultMessage="Welcome to your new {SPACE}! {emoji}"
                  id="NewSpaceBanner.Title"
                  values={{
                    emoji: '🎉',
                  }}
                />
              </h4>
              <p>
                <T
                  defaultMessage="Customize the blocks in your {SPACE} using Customize button or {key} hotkey."
                  id="NewSpaceBanner.Description"
                  values={{
                    key: <Hotkey variant="key">C</Hotkey>,
                  }}
                />
              </p>
            </div>
            <div>
              <Button
                onClick={() => push(relativeUrl)}
                variant="basic"
                leadingIcon={<XIcon />}
                rounded
                className="-mt-1 -me-1"
              ></Button>
            </div>
          </div>
          <div className="flex space-s-2">
            <Button
              variant="outline"
              leadingIcon={<CogIcon />}
              onClick={() => setSpaceSettingsModal(true)}
            >
              <T defaultMessage="Settings" id="Generics.Settings" />
            </Button>
            <Button
              variant="outline"
              leadingIcon={<PencilAltIcon />}
              onClick={() => push(`/manage/customizer/spaces/${id}/blocks`)}
            >
              <T defaultMessage="Customize" id="Generics.Customize" />
            </Button>
          </div>
        </Card.Content>
      </Card>
      {spaceSettingsModal && (
        <SpaceSettingsModal
          space={space}
          onClose={() => setSpaceSettingsModal(false)}
          open
        />
      )}
    </>
  )
}
